export default __webpack_public_path__ + "static/media/23_1_1.20d6fce3.png";